import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import { CircularProgress } from '@mui/material';

import Form from 'Lib/components/form/Form';
import Dialog from 'Lib/muiComponents/dialog/Dialog';

export const FormDialogActions = ({
    form,
    toggle,
    onCancel,
    onSaveAndAddAnother,
    ButtonProps: { color = 'success', text = 'Update', closeText = 'Close', disabled: ButtonDisabled }
}) => {
    const disabled = ButtonDisabled !== undefined ? (typeof ButtonDisabled === 'function' ? ButtonDisabled(form.values, form) : ButtonDisabled) : !form.dirty;

    const handleSubmit = (__, addAnother = false) => {
        if (onSaveAndAddAnother) {
            form.setSubmitting(true);
            onSaveAndAddAnother(form.values, form, addAnother).finally(() => form.setSubmitting(false));
        } else form.handleSubmit();
    };

    return (
        <Box>
            <Button data-cy={closeText} variant="outlined" color="success" onClick={() => (onCancel ? onCancel(form) : toggle())} sx={{ mr: 4, fontSize: '16px' }}>
                {closeText}
            </Button>

            {onSaveAndAddAnother && (
                <LoadingButton
                    loading={form.isSubmitting}
                    type="submit"
                    variant="contained"
                    color={color}
                    onClick={event => handleSubmit(event, true)}
                    loadingIndicator={<CircularProgress color={color} size={16} />}
                    disabled={disabled}
                    sx={{ mr: 4 }}
                >
                    {text} And Add Another
                </LoadingButton>
            )}

            <LoadingButton
                loading={form.isSubmitting}
                type="submit"
                variant="contained"
                data-cy={text}
                color={color}
                onClick={handleSubmit}
                loadingIndicator={<CircularProgress color={color} size={16} />}
                disabled={disabled}
            >
                {text}
            </LoadingButton>
        </Box>
    );
};

export default function FormDialog({
    sx,
    open,
    text,
    toggle,
    actions,
    children,
    onCancel,
    onSubmit,
    isLoading,
    fullWidth,
    initialValues,
    validationSchema,
    validate,
    enableReinitialize,
    onSaveAndAddAnother,
    ButtonProps = {},
    title = 'Edit',
    ...rest
}) {
    return (
        <Form
            key={open}
            onSubmit={onSubmit}
            initialValues={initialValues}
            enableReinitialize={enableReinitialize}
            validate={validate}
            validationSchema={validationSchema}
            render={form => (
                <form onSubmit={form.handleSubmit}>
                    <Dialog
                        {...rest}
                        title={title}
                        fullWidth={fullWidth}
                        open={open}
                        toggle={toggle}
                        onClose={onCancel}
                        sx={sx}
                        actions={() =>
                            actions ? (
                                actions(form)
                            ) : (
                                <FormDialogActions
                                    form={form}
                                    text={text}
                                    toggle={toggle}
                                    onSaveAndAddAnother={onSaveAndAddAnother}
                                    ButtonProps={ButtonProps}
                                    onCancel={onCancel}
                                />
                            )
                        }
                    >
                        {isLoading ? (
                            <Box justifyContent="center" display="flex">
                                <CircularProgress color="success" />
                            </Box>
                        ) : (
                            children(form)
                        )}
                    </Dialog>
                </form>
            )}
        />
    );
}
